import { type RcFile } from 'antd/es/upload'
import { createEffect } from 'effector'

import { UploadFileType } from '../api'
import { type UploadFileToPresignedUrlPayload } from '../model/upload-progress.model'
import { getAudioFileDuration } from './audio-helpers'
import {
  getCompressedImage,
  getImageAspectRatio,
  getImageAverageColor,
} from './image-helpers'

export function createExtractFileMetadataEffect() {
  return createEffect(
    async (
      file: RcFile,
    ): Promise<
      Omit<
        UploadFileToPresignedUrlPayload,
        | 'fileStartUpload'
        | 'fileProgressChanged'
        | 'fileUploadSuccess'
        | 'fileUploadError'
      >
    > => {
      let resultFile = file
      let duration = null
      let aspectRatio = 0
      let dominantColor = null
      let fileType = UploadFileType.Document
      if (resultFile.type.startsWith('audio/')) {
        duration = await getAudioFileDuration(resultFile)
        fileType = UploadFileType.Track
      } else if (resultFile.type.startsWith('image/')) {
        resultFile = await getCompressedImage(resultFile)
        fileType = UploadFileType.Image
        aspectRatio = await getImageAspectRatio(file)
        dominantColor = await getImageAverageColor(resultFile)
      } else if (resultFile.type.startsWith('application/')) {
        fileType = UploadFileType.Document
      }
      return {
        uid: resultFile.uid,
        fileName: resultFile.name,
        fileType,
        duration,
        file: resultFile,
        aspectRatio,
        dominantColor,
      }
    },
  )
}
